import type { RouteObject } from 'react-router'
import { create } from 'zustand'

type LoadingState = { isLoading: boolean; minWidth?: number; maxWidth?: number }

type BreadcrumbsState = {
  dynamicLabels: Record<string, string>
  loadingStates: Record<string, LoadingState>
  routes: RouteObject[]
  setRoutes: (routes: RouteObject[]) => void
  setDynamicLabel: (paramName: string, label: string) => void
  setLoadingState: (
    paramValue: string,
    loading: boolean,
    minWidth?: number,
    maxWidth?: number
  ) => void
  getDynamicLabel: (segment: string) => string | null
  getLoadingState: (segment: string) => LoadingState | null
  clearDynamicLabels: () => void
}

export const useBreadcrumbStore = create<BreadcrumbsState>((set, get) => ({
  dynamicLabels: {},
  loadingStates: {},
  routes: [],

  setRoutes: (routes) => set({ routes }),

  setDynamicLabel: (paramValue, label) =>
    set((state) => ({
      dynamicLabels: { ...state.dynamicLabels, [paramValue]: label }
    })),

  setLoadingState: (paramValue, isLoading, minWidth = 60, maxWidth = 120) =>
    set((state) => ({
      loadingStates: {
        ...state.loadingStates,
        [paramValue]: { isLoading, minWidth, maxWidth }
      }
    })),

  getDynamicLabel: (segment) => {
    return get().dynamicLabels[segment] || null
  },

  getLoadingState: (segment) => {
    return get().loadingStates[segment] || null
  },

  clearDynamicLabels: () =>
    set({
      dynamicLabels: {},
      loadingStates: {}
    })
}))
